module.exports = __webpack_public_path__ + "static/img/4_2_1.9e46d9e9.jpg";